import api from "../../utils/appApi";
import inputsValidation from '../../utils/inputsValidation';
import FormField from '../../utils/form-field';
import Notify from '../../utils/notify';
import ButtonState from "../../utils/buttonState";
const $sendMailButtonState = new ButtonState($('#send-email-btn'));
const notifier = new Notify();

(function() {
	$(document).ready(function() {
		const emailUsValidation = new inputsValidation({ target: $('#email-us').get()[0] });

		/**
		 * Clear all fields in 'Email Us' form
		 */
		const clearEmailUsForm = () => {
			$('#name').val('');
			$('#email').val('');
			$('#message').val('');
			FormField.toggleFilledAllInputs();
		};

		const buildRequest = () => {
			return {
				name: $('#name').val(),
				email: $('#email').val(),
				message: $('#message').val()
			};
		};

		const onSuccess = (response) => {
			notifier.success(response.data.message);
			$('#send-email-btn').remove();
			clearEmailUsForm();
		};

		const onError = (error) => {
			notifier.error(error.response.data.message);
			$sendMailButtonState.reset();
		};

		/**
		 * Sending email on button click
		 */
		$('#send-email-btn').on('click', function() {
			if (emailUsValidation.handle()) {
				$sendMailButtonState.loading();
				const request = buildRequest();
				api.public.contactForm.send(request)
					.then((response) => {
						onSuccess(response);
					})
					.catch((error) => {
						onError(error);
					});


				console.log('Send message!');
			}
		});
	})
})();
